// https://codepen.io/karpovsystems/pen/fFHxK

import createSvg from './createSvg';
import urlParams from '../functions/urlParams';

//const PAGE_URL_ATTR = 'data-page-url';
const LI_CLASS = 'c-ajax-paging__item';
const LI_SEP_CLASS = `${LI_CLASS}--separator`;
const LI_ACTIVE_CLASS = `${LI_CLASS}--active`;
const LI_DISABLE_CLASS = `${LI_CLASS}--disable`;
const LI_PREV_CLASS = `${LI_CLASS}--prev`;
const LI_NEXT_CLASS = `${LI_CLASS}--next`;
const LINK_CLASS = 'c-ajax-paging__link';
const LIST_ANCHOR = 'productList';

let options;
let element;
let fragment = document.createDocumentFragment();
let pageParams;

let clickEvent = function(event) {
  let li = this.parentNode;

  if (li.classList.contains(LI_ACTIVE_CLASS) || li.classList.contains(LI_DISABLE_CLASS)) {
    event.preventDefault();
  }
};

let createItem = function(inner, cssClass, cssClass2) {
  let li = document.createElement('li');
  li.classList.add(LI_CLASS);

  if (cssClass) {
    li.classList.add(cssClass);
  }

  if (cssClass2) {
    li.classList.add(cssClass2);
  }

  li.appendChild(inner);
  fragment.appendChild(li);
};

let createLink = function(page, node = null) {
  pageParams['page'] = page;

  let a = document.createElement('a');
  a.classList.add(LINK_CLASS);
  a.setAttribute('href', `${urlParams.buildQuery(pageParams)}#${LIST_ANCHOR}`);

  if (node) {
    a.appendChild(node);
  }
  else {
    a.innerHTML = page;
  }

  a.addEventListener('click', clickEvent);

  return a;
};

let createSeparator = function() {
  let i = document.createElement('i');
  i.classList.add(LINK_CLASS);
  i.textContent = '…';

  return i;
};

let add = function(s, f) {
  for (var i = s; i < f; i++) {
    createItem(createLink(i), i === options.page ? LI_ACTIVE_CLASS : null);
  }
};

let last = function() {
  createItem(createSeparator(), LI_SEP_CLASS);
  createItem(createLink(options.size), options.size === options.page ? LI_ACTIVE_CLASS : null);
};

let first = function() {
  createItem(createLink(1), options.page === 1 ? LI_ACTIVE_CLASS : null);
  createItem(createSeparator(), LI_SEP_CLASS);
};

let finish = function() {
  element.innerHTML = '';
  element.appendChild(fragment);
};

let start = function() {
  if (options.size < options.step * 2 + 6) {
    add(1, options.size + 1);
  }
  else if (options.page < options.step * 2 + 1) {
    add(1, options.step * 2 + 4);
    last();
  }
  else if (options.page > options.size - options.step * 2) {
    first();
    add(options.size - options.step * 2 - 2, options.size + 1);
  }
  else {
    first();
    add(options.page - options.step, options.page + options.step + 1);
    last();
  }

  arrowRight();
  finish();
};

let arrowLeft = function() {
  let disabled = false;
  let page = options.page - 1;

  if (page < 1) {
    disabled = true;
    page = 1;
  }

  createItem(createLink(page, createSvg('arrow')), LI_PREV_CLASS, disabled ? LI_DISABLE_CLASS : null);
};

let arrowRight = function() {
  let disabled = false;
  let page = options.page + 1;

  if (page > options.size) {
    disabled = true;
    page = options.size;
  }

  createItem(createLink(page, createSvg('arrow')), LI_NEXT_CLASS, disabled ? LI_DISABLE_CLASS : null);
};

export default function(_element, _options) {
  options = _options;
  element = _element;
  pageParams = urlParams.getAll();

  arrowLeft();
  start();
};
